import React, {FC} from 'react';
import styles from './BackToTop.module.scss';

interface BackToTopProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

const BackToTop: FC<BackToTopProps> = ({ 
  onClick, 
  label = 'Наверх',
  className 
}) => {
  return (
    <button type="button" className={styles.backToTop} onClick={onClick}>
      <span className={styles.icon}>↑</span>
      <span>{label}</span>
    </button>
  );
};

export default BackToTop;

